module.exports = __webpack_public_path__ + "img/aeroland-payment-box-icon-02.5370fbcd.png";